<template>
  <div class="base service">
    <cursor-fx ref="cursor" />
    <section id="load_grid"></section>
    <section id="white_lay"></section>
    <section id="black_lay"></section>
    <section id="op_base" class="flex_wrapper">
      <div class="catche">
        <p class="one">Service</p>
        <!--<p class="sub">COMPANY</p>-->
      </div>
      <div class="m-mv__main__scroll js-opening-scroll">
        <div class="c-scroll-down js-scroll" data-scroll="#main">
          <span class="txt">Scroll</span><span class="line"></span>
        </div>
      </div>
    </section>
    <section id="op_stage">
      <div class="bg_mv_cov">
        <canvas class="canvas-container"></canvas>
        <div></div>
      </div>
    </section>
    <section class="under_wrapper">
      <section class="under_top sec_pad_1 lo_right">
        <article class="flex_wrapper bxs anim_tgt defo_ua">
          <div class="tx bx">
            <h2 class="h_type_1 jp">
              テキスト／テキスト／<br>
              テキスト／テキスト／<br class="sp">テキスト／テキスト。
            </h2>
            <p>
              テキスト／テキスト／テキスト／テキスト／<br>
              テキスト／テキスト。<br><br>
              <span class="b">
              -テキスト／テキスト／テキスト／テキスト／<br>
              -テキスト／テキスト／テキスト／テキスト／<br>
              -テキスト／テキスト／テキスト／テキスト／
              </span><br><br>
              テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。
            </p>
          </div>
          <div class="px bx"></div>
        </article> 
      </section>
        <article class="lo_right">
          <div class="lo_inn anim_tgt up_fade">
            <div class="flex_wrapper dtl">
              <div class="tx bx">
                <h2 class="h_type_1 jp">
                  テキスト／テキスト／ テキスト
                </h2>
                <p>
                 <span class="b fs_120per">テキスト／テキスト／テキスト／テキスト／</span><br>
                 テキスト／テキスト／テキスト／テキスト。<br>
                 テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。<br><br>
                 テキスト／テキスト／テキスト／テキスト。<br>
                 テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。
                </p>
              </div>
            </div>    
          </div>
        </article> 
        <article class="big_pix sec_pad_1">
          <div class="inn flex_wrapper anim_tgt up_fade">
            <div class="px pc">
              <img src="../img/about_px_3.jpg" alt="*">
            </div>  
            <div class="tx">
                <h2 class="h_type_1 jp">
                  テキスト／テキスト／ テキスト
                </h2>
                <div>
                 <span class="b fs_120per">テキスト／テキスト／テキスト／テキスト／</span><br><br>
                 <figure class="sp">
                  <img src="../img/about_px_3.jpg" alt="*" class="max_img">                  
                 </figure>
                 <span class="msg"> 
                 テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。<br><br>
                 テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。<br><br>
                 テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。<br>
                 テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。
                 </span>
                </div>
            </div>  
          </div> 
        </article> 
        <div class="btn_px_type anim_tgt up_fade">
          <a href="#" data-cursor-hover>
            <img src="../img/btn_px.jpg" alt="*">
            <h2 class="h_type_1 ssz">
              CONTACT
            </h2>
          </a>          
        </div>
      <section id="common_cvs">
        <canvas class="canvas-container_2"></canvas>
      </section>

    </section>
  </div>
</template>
<script>
// @ is an alias to /src
import { TimelineMax } from "gsap";
import { under_op } from "@/js/under_op.js";
import { particle } from "@/js/particle.js";
import { bg_mv } from '@/js/bg_mv.js';
import { header_fix } from '@/js/header_fix.js';
import { scroll_anim } from '@/js/scroll_anim.js';
import { common } from '@/js/common.js';
export default {
  name: "Service",
  mounted() {
    const timeline = new TimelineMax();
    const wh = window.innerWidth;
    under_op(timeline, wh);
    header_fix();
    particle(".bg_mv_cov", ".canvas-container");
    particle('#common_cvs','.canvas-container_2'); 

    bg_mv();
    let scrollElem = document.querySelectorAll('.anim_tgt');
    scroll_anim(scrollElem);
    let tgt = document.querySelector(".switchWrap"); 
    common(tgt);
    document.body.className = "under service";
    this.$root.headerHide = true;
    this.$root.footerHide = true;
  },
  methods: {
    others() {
		  this.$refs.cursor.refresh();
    }
  },    
   beforeDestroy() {
    document.body.className = '';
    this.$root.headerHide = false;
    this.$root.footerHide = false;
  }
};
</script>